export const getBikeTypeKey = 'getBikeType';
export const getBikeMarkKey = 'getBikeMark';
export const getBikeModelKey = 'getBikeModel';
export const getBikeBodyTypeKey = 'getBikeBodyType';
export const getBikeModificationKey = 'getBikeModification';
export const getBikeCharacteristicKey = 'getBikeCharacteristic';
export const getBikeEngineVolumeKey = 'getBikeEngineVolume';
export const getBikePowerKey = 'getBikePower';
